import { z } from 'zod';

export const AuthRequiredToolName = 'auth_required';

/**
 * Auth required tool arguments schema
 */
export const authRequiredToolArgsSchema = z.object({
  action: z.string().describe('The action user is trying to perform'),
  reason: z.string().optional().describe('Why authentication is required'),
});

export type AuthRequiredToolArgs = z.infer<typeof authRequiredToolArgsSchema>;

/**
 * Auth required tool response schema
 */
export const authRequiredToolDef = z.object({
  requiresAuth: z
    .literal(true)
    .describe('Indicates authentication is required'),
  content: z
    .string()
    .describe('Natural language message explaining authentication requirement'),
  suggestedAction: z
    .literal('login')
    .describe('Suggested action for the user to take'),
});

export type AuthRequiredToolDef = z.infer<typeof authRequiredToolDef>;
